import React from 'react';
import { useGeoPrice } from '../hooks/useGeoPrice';
const PURCHASE_URL = 'https://pay.hotmart.com/R104430088E?bid=1770999394323';
export function HeroSection() {
  return <section className="relative w-full overflow-hidden" data-id="element-142">
      {/* Background effects */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[600px] rounded-full opacity-30 pointer-events-none" style={{
      background: 'radial-gradient(ellipse, rgba(88, 28, 135, 0.4) 0%, transparent 70%)'
    }} aria-hidden="true" data-id="element-143" />
      <div className="absolute top-[-100px] left-1/2 -translate-x-1/2 w-[400px] h-[300px] rounded-full opacity-20 pointer-events-none" style={{
      background: 'radial-gradient(ellipse, rgba(251, 191, 36, 0.3) 0%, transparent 70%)'
    }} aria-hidden="true" data-id="element-144" />

      <div className="relative max-w-5xl mx-auto px-5 pt-6 pb-12 md:pt-12 md:pb-28" data-id="element-145">
        {/* 🔥 SUPER PROMO BANNER — First impression */}
        <div className="mb-6 md:mb-10 rounded-2xl border-2 border-amber-500/50 bg-gradient-to-r from-amber-500/10 via-red-500/10 to-amber-500/10 p-5 sm:p-6 text-center relative overflow-hidden" data-id="element-146">
          <div className="absolute inset-0 bg-amber-500/5 animate-pulse pointer-events-none" data-id="element-147" />
          <div className="relative z-10" data-id="element-148">
            <p className="text-red-400 text-xs sm:text-sm font-black uppercase tracking-widest mb-2 animate-pulse" data-id="element-149">
              🔥 Super Promo — Solo por esta semana 🔥
            </p>
            <h2 className="text-lg sm:text-xl md:text-2xl font-black text-white leading-snug mb-3" data-id="element-150">
              ¡Nos volvimos locos! Como agradecimiento por tus compras hemos
              bajado los precios de todos nuestros productos a tan solo{' '}
              <span className="text-amber-400 text-2xl sm:text-3xl md:text-4xl" data-id="element-151">
                $7.99 USD
              </span>
            </h2>
            <p className="text-gray-300 text-sm mb-4" data-id="element-152">
              ⚡ Aprovecha, se acaba pronto
            </p>
            <a href="#comprar" className="cta-hero-glow inline-flex flex-col items-center justify-center bg-amber-500 hover:bg-amber-400 text-black px-8 sm:px-10 py-3 sm:py-4 rounded-2xl transition-colors" data-id="element-153">
              <span className="font-black text-base sm:text-lg" data-id="element-154">
                ¡QUIERO APROVECHARLO! — $7.99 USD
              </span>
              <span className="text-black/60 text-[10px] sm:text-xs font-semibold mt-0.5" data-id="element-155">
                ⚡ Antes de que suba el precio
              </span>
            </a>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-6 md:gap-16" data-id="element-156">
          {/* Text Content */}
          <div className="flex-1 text-center md:text-left z-10" data-id="element-157">
            {/* Eyebrow */}
            <div className="mb-4 md:mb-8" data-id="element-158">
              <div className="inline-flex items-center gap-2 sm:gap-3 bg-amber-500/10 border border-amber-500/30 rounded-full px-4 sm:px-6 py-2 sm:py-3" data-id="element-159">
                <span className="text-amber-400 text-sm sm:text-lg md:text-2xl font-black tracking-wide uppercase" data-id="element-160">
                  Ebook + Audiolibro + 5 Bonos
                </span>
                <span className="flex-shrink-0 bg-amber-500 text-black text-[10px] sm:text-xs font-black uppercase px-2 sm:px-2.5 py-0.5 sm:py-1 rounded-full animate-pulse" data-id="element-161">
                  HOY
                </span>
              </div>
            </div>

            {/* Headline */}
            <h1 className="text-xl sm:text-2xl md:text-4xl lg:text-5xl font-bold text-white leading-snug mb-4 md:mb-8" data-id="element-162">
              Transforma tu vida con un sistema{' '}
              <span className="text-amber-400 drop-shadow-lg" data-id="element-163">
                que realmente funciona.
              </span>
            </h1>

            {/* Opening lead — hidden on mobile */}
            <div className="hidden md:block space-y-5 text-lg leading-relaxed text-gray-200 mb-10" data-id="element-164">
              <p data-id="element-165">
                Descubre nuestra exclusiva colección de recursos digitales
                diseñados para impulsar tu{' '}
                <strong className="text-white" data-id="element-166">
                  crecimiento personal, financiero y espiritual.
                </strong>
              </p>
              <p data-id="element-167">
                Ebooks, audiolibros y herramientas prácticas como trackers de
                hábitos y guías especializadas, cuidadosamente seleccionados
                para ayudarte a alcanzar tus objetivos.
              </p>
              <p data-id="element-168">
                Estrategias aplicables en tu día a día que te permitirán{' '}
                <strong className="text-amber-200" data-id="element-169">
                  desarrollar nuevas habilidades, superar obstáculos y avanzar
                  con confianza hacia tus metas.
                </strong>
              </p>
            </div>

            {/* Short mobile-only lead */}
            <p className="md:hidden text-base text-gray-300 leading-relaxed mb-5" data-id="element-170">
              Recursos digitales para impulsar tu{' '}
              <strong className="text-white" data-id="element-171">
                crecimiento personal, financiero y espiritual.
              </strong>
            </p>

            {/* CTA */}
            <div className="flex flex-col items-center md:items-start gap-2" data-id="element-172">
              <div className="flex items-center gap-3 mb-1" data-id="element-173">
                <span className="text-gray-400 line-through text-base sm:text-lg" data-id="element-174">
                  $47.99 USD
                </span>
                <span className="bg-red-500/90 text-white text-[10px] sm:text-xs font-black uppercase px-2 py-0.5 rounded-full" data-id="element-175">
                  -83% OFF
                </span>
              </div>
              <a href={PURCHASE_URL} className="cta-hero-glow relative inline-flex flex-col items-center justify-center bg-amber-500 hover:bg-amber-400 text-black px-10 py-4 sm:py-5 rounded-2xl transition-colors w-full sm:w-auto" data-id="element-176">
                <span className="relative z-10 font-black text-lg sm:text-xl" data-id="element-177">
                  SUPER PROMO — $7.99 USD
                </span>
                <span className="relative z-10 text-black/60 text-[11px] sm:text-xs font-semibold mt-0.5" data-id="element-178">
                  ⚡ Solo por esta semana
                </span>
              </a>
              <span className="text-xs text-gray-500" data-id="element-179">
                Acceso inmediato · Descarga digital · Pago seguro
              </span>
            </div>
          </div>

          {/* Product Image */}
          <div className="flex-1 w-full max-w-[280px] md:max-w-[500px] relative" data-id="element-180">
            <div className="absolute inset-0 bg-amber-500/20 blur-[60px] rounded-full pointer-events-none" data-id="element-181" />
            <img src="https://cdn.magicpatterns.com/uploads/qKirUDVmQuT63BJVzAPPXS/Super_Pack.png" alt="Hábitos Atómicos Espirituales Super Pack" className="relative z-10 w-full h-auto drop-shadow-2xl" loading="eager" data-id="element-182" />
          </div>
        </div>
      </div>

      <div className="section-divider" aria-hidden="true" data-id="element-183" />
    </section>;
}